/* ============================================================================
   Labrigart – Produktbeschreibung auf der PDP kuerzen  (Vorgang n:250)
   ----------------------------------------------------------------------------
   Fortschrittliche Verbesserung (progressive enhancement):
   - Ausgangs-DOM zeigt die volle Beschreibung. Ohne dieses Skript aendert sich
     nichts – kein Knopf, kein Fade, voller Text (barrierefrei/robust).
   - Dieses Skript misst je Beschreibung, ob der Inhalt hoeher als das per CSS
     gesetzte Limit (--lbrgt-desc-max, ~6 Zeilen) ist. Nur dann:
       * bekommt der Wrapper .is-collapsed (CSS klappt ein + Fade)
       * wird der Knopf sichtbar (Attribut hidden entfaellt)
   - Klick auf den Knopf schaltet ein-/ausgeklappt um und pflegt aria-expanded
     sowie den Beschriftungstext.
   Kein Framework. Angelehnt an die uebrigen lbrgt-*.js (schlichtes IIFE).
   ========================================================================== */
(function () {
  'use strict';

  var SEL = '[data-lbrgt-pdp-desc]';
  var TOLERANZ = 4; // px – kleine Reserve gegen Sub-Pixel-Rundung

  function beschriftung(wrap, ausgeklappt) {
    var l = wrap.querySelector('[data-lbrgt-pdp-desc-toggle-label]');
    if (l) l.textContent = ausgeklappt ? 'Weniger anzeigen' : 'Mehr anzeigen';
  }

  /* Misst und entscheidet, ob eingeklappt wird. Laeuft NUR, solange der Nutzer
     nicht selbst ausgeklappt hat (dann nicht dazwischenfunken). */
  function bewerten(wrap) {
    var body = wrap.querySelector('[data-lbrgt-pdp-desc-body]');
    var btn = wrap.querySelector('[data-lbrgt-pdp-desc-toggle]');
    if (!body || !btn) return;
    if (btn.getAttribute('aria-expanded') === 'true') return;

    // erst einklappen, dann pruefen, ob der Inhalt ueberlaeuft
    wrap.classList.add('is-collapsed');
    var laeuftUeber = body.scrollHeight - body.clientHeight > TOLERANZ;

    if (laeuftUeber) {
      wrap.classList.add('is-collapsible');
      btn.hidden = false;
      beschriftung(wrap, false);
    } else {
      // kurzer Text: nichts einklappen, kein Knopf, kein Fade
      wrap.classList.remove('is-collapsed', 'is-collapsible');
      btn.hidden = true;
    }
  }

  function umschalten(wrap) {
    var btn = wrap.querySelector('[data-lbrgt-pdp-desc-toggle]');
    if (!btn) return;
    var ausgeklappt = btn.getAttribute('aria-expanded') === 'true';
    if (ausgeklappt) {
      wrap.classList.add('is-collapsed');
      btn.setAttribute('aria-expanded', 'false');
      beschriftung(wrap, false);
    } else {
      wrap.classList.remove('is-collapsed');
      btn.setAttribute('aria-expanded', 'true');
      beschriftung(wrap, true);
    }
  }

  function init(root) {
    var liste = (root || document).querySelectorAll(SEL);
    for (var i = 0; i < liste.length; i++) {
      var wrap = liste[i];
      if (wrap.dataset.lbrgtPdpDescReady) {
        bewerten(wrap);
        continue;
      }
      wrap.dataset.lbrgtPdpDescReady = '1';
      var btn = wrap.querySelector('[data-lbrgt-pdp-desc-toggle]');
      if (btn) {
        btn.addEventListener('click', (function (w) {
          return function () { umschalten(w); };
        })(wrap));
      }
      bewerten(wrap);
    }
  }

  function bereit(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  bereit(function () { init(document); });
  // nach Schriften/Bildern erneut messen (Hoehe kann sich aendern)
  window.addEventListener('load', function () { init(document); });
  // Theme-Editor: Sektion neu geladen
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });

  // Breitenaenderung: nur noch eingeklappte Beschreibungen neu bewerten
  var t;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(function () {
      var liste = document.querySelectorAll(SEL);
      for (var i = 0; i < liste.length; i++) {
        var wrap = liste[i];
        var btn = wrap.querySelector('[data-lbrgt-pdp-desc-toggle]');
        if (btn && btn.getAttribute('aria-expanded') === 'true') continue;
        wrap.classList.remove('is-collapsed', 'is-collapsible');
        if (btn) btn.hidden = true;
        bewerten(wrap);
      }
    }, 200);
  });
})();
